export class CountryFakeData {
    public static countries = [
      {
        id: 1,
        countryName: 'INDIA',
        blocked:true,
      },
      {
        id: 2,
        countryName: 'USA',
        blocked:true,
      },
      {
        id: 3,
        countryName: 'CHINA',
        blocked:false,
      },
      {
        id: 4,
        countryName: 'SOUTH AFRICA',
        blocked:true,
      },
      {
        id: 5,
        countryName: 'WEST INDIES',
        blocked:true,
      },
      {
        id: 6,
        countryName: 'ENGLAND',
        blocked:false,
      },
      {
        id: 7,
        countryName: 'AUSTRALIA',
        blocked:true,
      },
      {
        id: 8,
        countryName: 'SRI LANKA',
        blocked:true,
      },
      {
        id: 9,
        countryName: 'BERMUDA',
        blocked:true,
      },
      {
        id: 10,
        countryName: 'HOLAND',
        blocked:true,
      }
    ];
  }
  